import React from 'react';
import { I18nextProvider } from 'react-i18next';
import Navbar from "./components/Navbar";
import Header from "./sections/Header";
import WhatWeDo from "./sections/WhatWeDo";
import KeyFeatures from "./sections/KeyFeatures";
import WhyHurrlink from "./sections/WhyHurrlink";
import HowitWorks from "./sections/HowItWorks";
import ForBanks from "./sections/ForBanks";
import Coverage from "./sections/Coverage";
import JoinHurrlink from "./sections/JoinHurrlink";
import Footer from "./sections/Footer";
import i18n from "./i18n"

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <div>
        <Navbar />
        <Header />
        <WhatWeDo />
        <KeyFeatures />
        <WhyHurrlink />
        <HowitWorks />
        <ForBanks />
        <Coverage />
        <JoinHurrlink />
        <Footer />
      </div>
    </I18nextProvider>
  );
}

export default App;